import React from "react";
import "./ToggleButton.css";

export const ToggleButton = ({
  toggled = false,
  toggle,
  canEditAccess = false,
}) => {
  return (
    <div
      className={
        canEditAccess ? "ToggleButton ToggleButton--allowed" : "ToggleButton"
      }
      style={{ backgroundColor: toggled ? "#53A682" : "#848C96" }}
      onClick={() => toggle(!toggled)}
    >
      <div
        className="ToggleButton__floater"
        style={{ right: toggled ? "3px" : "31px" }}
      ></div>
    </div>
  );
};
